import React, { Component } from 'react';
import ComponentContract from './ComponentContract';
import SelectIncubator from '../../SelectIncubator';

class BaseForm extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentWillMount() {}

  componentDidMount() {}

  componentWillReceiveProps(nextProps) {}

  handleIncuChange = e => {
    this.setState({
      incuUuid: e,
    });
  };

  render() {
    const { incuUuid } = this.state;
    return (
      <div>
        <SelectIncubator onChange={this.handleIncuChange} />
        <ComponentContract {...this.props} incuUuid={incuUuid} />
      </div>
    );
  }
}

export default BaseForm;



// WEBPACK FOOTER //
// ./src/components/incubator/contract/index/Index.js